// extracted by mini-css-extract-plugin
export var background = "bV_f0";
export var body = "bV_fz";
export var button = "bV_bT";
export var card = "bV_dc";
export var content = "bV_S";
export var footer = "bV_f1";
export var header = "bV_fZ";
export var subtitle = "bV_fF";
export var title = "bV_7";